import {
  ApplicationConfig,
  CSP_NONCE,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MatDialogModule } from '@angular/material/dialog';
import { CdsLanguageModule, CdsLangService } from '@cds/ng-core/lang';

import { authInterceptor } from '@core/interceptors/auth.interceptor';
import { INIT_ENV_DATA } from '@core/init/env.init';
import { INIT_LANG_DATA } from '@core/init/lang.init';
import { EnvConfigService } from '@core/services/env-config.service';
import { PaymentGatewayService } from '@core/services/payment-gateway.service';

import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(appRoutes, withHashLocation()),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimationsAsync(),
    importProvidersFrom(MatDialogModule, CdsLanguageModule),
    PaymentGatewayService,
    provideAppInitializer(() => INIT_LANG_DATA(inject(CdsLangService))()),
    provideAppInitializer(() => INIT_ENV_DATA(inject(EnvConfigService))()),
    { provide: CSP_NONCE, useValue: 'randomNonceCsp' },
  ],
};
